<script>
  const toTheTop = () => {
    window.scrollTo(0, 0);
  };
</script>

<footer class="container">
  <div class="meju-foot">
    <div class="meju-wrapper">
      <div class="icon-wrapper" on:click={toTheTop}>
        <img src="/imgs/meju.png" alt="메쥬 로고" class="meju-icon rotating" />
      </div>
    </div>
    <div class="meju-info">
      <div class="content title">황금메쥬</div>
      <div class="content">
        경북 구미시 금오산로 22길 6<br />지하 1층 황금메쥬
      </div>
      <div class="content">사업자번호 : 630-71-00494</div>
      <div class="content" style="margin-bottom:10px;">
        대표전화 : 010-9512-7502
      </div>

      <div class="content">이메일 : cht1589@gmail.com</div>
      <div class="content">카카오톡 : 황금메쥬</div>
      <div class="content">인스타그램 : golden_meju</div>
    </div>
    <!-- <div class="menus">
      <ul class="menu-list">
        <li><a href="#intro"><span class="curtain" /> - 소개</a></li>
        <br />
        <li><a href="#price"><span class="curtain" />- 가격표</a></li>
        <br />
        <li>
          <a href="#location"><span class="curtain" />- 위치 & 예약일정</a>
        </li>
        <br />
        <li>
          <a href="#reservation"><span class="curtain" />- 상담 및 예약</a>
        </li>
      </ul>
    </div> -->
  </div>
  <div class="my-foot">
    Copyright 황금메쥬 | All Rights Reserved. <br /> designed & developed by 황원준
    | E-mail : iamjam4944@gmail.com
  </div>
</footer>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300&display=swap');

  .container {
    color: #f3f3f3;
    margin: 0;
    width: 100%;
    background-color: #333;
  }
  .meju-foot {
    /* width: 1280px; */
    width: 70%;
    margin: 0 auto;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .meju-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-wrapper {
    width: 150px;
    height: 150px;
    border-radius: 100px;
    overflow: hidden;
    background-color: #f3f3f3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 2px 4px #f0b001;
    transition: 0.3s;
  }
  .icon-wrapper:hover {
    box-shadow: 6px 6px 9px #fdb501;
    transform: translate(-4px, -4px);
    /* transform: rotateZ(-20deg); */
    cursor: pointer;
  }
  .icon-wrapper:active {
    transition: 0.1s;
    transform: translate(4px, 4px);
    box-shadow: 0px 0px 0px #333;
  }

  .meju-icon {
    width: 95%;
    height: 95%;
    padding-bottom: 3%;
    object-fit: cover;
  }
  .meju-info {
    flex: 1;
  }
  .meju-info .content {
    font-size: 12px;
    margin: 0;
    margin-bottom: 4px;
    word-wrap: keep-all;
  }
  .meju-info .content.title {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  .meju-info .content.title::after {
    content: 'Golden Meju';
    font-size: 10px;
    font-weight: 100;
  }

  .menus {
    flex: 1;
  }
  .menu-list a {
    text-decoration: none;
    color: #f3f3f3;
  }
  .menu-list li {
    position: relative;
    display: inline-block;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 300;
    font-size: 24px;
  }
  .menu-list .curtain {
    position: absolute;
    background-color: #f3f3f3;
    width: 0%;
    left: 0;
    bottom: 0;
    height: 2px;
    transition: 0.3s;
  }
  .menu-list li:hover .curtain {
    width: 100%;
  }
  .my-foot {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 300;
    background-color: #222;
    height: 100px;
    text-align: center;
    font-size: 18px;
    line-height: 30px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .rotating {
    -webkit-animation: rotating 15s linear infinite;
    -moz-animation: rotating 15s linear infinite;
    -ms-animation: rotating 15s linear infinite;
    -o-animation: rotating 15s linear infinite;
    animation: rotating 15s linear infinite;
  }
  @media screen and (max-width: 768px) {
    .meju-foot {
      width: 100%;
    }
    .my-foot {
      font-size: 3vw;
    }
  }
</style>
